function searchCustomeBase(params) {
    return Vue.prototype.$_sAjax.get('/cl/CustomFields/GetCustomerByView', { params });
}

export default function(params) {
    return new Promise((resolve, reject) => {
        const keyWord = params.name;

        const defaultParams = {
            sortKey: 'lastModifiedTime',
            sortType: 'desc',
            page: 0,
            size: 30
        };

        const ajaxParams = {
            ...defaultParams,
            ...{
                'filters[0][field]': 'Owner',
                'filters[0][operation]': '==',
                'filters[0][value]': 'all',
                keywords: keyWord
            }
        };

        searchCustomeBase(ajaxParams).then(
            res => {
                if (window.parseInt(res.r) === 0 && res.records) {
                    const list = res.records.map(x => {
                        return {
                            face: x.avatar,
                            uin: x.id,
                            id: x.id,
                            name: x.Name
                        };
                    });
                    resolve({
                        list
                    });
                } else {
                    reject(res);
                }
            },
            err => {
                reject(err);
            }
        );
    });
}
